export function addFilters(...filters) {
  const params = new URLSearchParams();

  params.set("filters", filters.map(encodeURIComponent).join(","));

  return params;
}
